import * as firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

const app = firebase.initializeApp({
    apiKey: "AIzaSyB_I-d4VkPRqfpxPRFybA4lFvawyNir8a8",
    authDomain: "podcast-chatterbox.firebaseapp.com",
    databaseURL: "https://podcast-chatterbox.firebaseio.com",
    projectId: "podcast-chatterbox",
    storageBucket: "podcast-chatterbox.appspot.com",
    messagingSenderId: "702377754806"
});

// const app = firebase.initializeApp({
//     apiKey: process.env.REACT_APP_FIREBASE_KEY,
//     authDomain: process.env.REACT_APP_FIREBASE_DOMAIN,
//     databaseURL: process.env.REACT_APP_FIREBASE_DATABASE,
//     projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
//     storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
//     messagingSenderId: process.env.REACT_APP_FIREBASE_SENDER_ID
// });

export default app

